module.exports = __webpack_public_path__ + "static/media/background.3b2499de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/brand/brands/wellnet/media/background.jpg
// module id = 854
// module chunks = 0